import { createStore } from 'vuex'
import { setSession, getSession, setLocal, getLocal, mdCrtpto } from '@/util'
import { getCompleteAddress } from '@/util/bMap'
import { getCountOfShoppingCar } from '@/api/shoppingCar'
import { getMyDefault, myCarList as getMyCarList } from '@/api/car'
import { getCustomerInfo } from '@/api/mine'
let { origin, pathname, hostname } = location
/**
 * VUE_APP_DEPLOYMENT = 'PROD' 为生产环境
 * VUE_APP_DEPLOYMENT = 'TEST' 为测试环境
 * VUE_APP_DEPLOYMENT = 'LOCAL' 为开发本地环境
 * VUE_APP_DEPLOYMENT = 'UAT' 为uat环境
 */
// 友好备注：这里的 isProduct 是 是否是生产环境 的意思。
let isProduct = process.env.VUE_APP_DEPLOYMENT === 'PROD'
// let domain = isProduct ? origin : ''
let staticDomain = process.env.VUE_APP_BLOB_ENDPOINT

// 友好备注：这里暂时保持老逻辑，暂时不切换成VUE_APP_DEPLOYMENT， 不确定scope。
let env = hostname.split('.')[0].split('-')[1]

export default createStore({
  state: {
    //友好备注：经查询这个domain 没用到，所以我注掉了
    // domain,
    staticDomain,
    env,
    isProduct,
    dealerInfo: getSession('dealerInfo'),
    loyaltyDealerInfo: getSession('loyaltyDealerInfo'),
    oabInfo: getSession('oabInfo'),
    loyalty: getSession('loyalty'),
    loyaltyId: getSession('loyaltyId'),
    brandInfo: getSession('brandInfo'),
    currentGoodsInfo: getSession('currentGoodsInfo'),
    currentCarInfo: getSession('currentCarInfo'),
    currentCarClassInfo: getSession('currentCarClassInfo'),
    currentBuyProductInfo: getSession('currentBuyProductInfo'),
    myCarList: getSession('myCarList'),
    shoppingCarSelect: getSession('shoppingCarSelect'),
    currentNotificationData: [],
    currentCity: getSession('currentCity'),
    currentTyre: getSession('currentTyre'),
    currentShop: getSession('currentShop'),
    currentContacts: getSession('currentContacts'),
    dealerJoinPlanFlag: getSession('dealerJoinPlanFlag'),
    locationInfo: getSession('locationInfo'),
    loyaltyApplyDealerParam: getSession('loyaltyApplyDealerParam') || {
      loyaltyId: '',
      gsCode: ''
    },
    formattedAddress: '定位失败',
    shoppingCarCount: 0,
    position: getSession('position') || {
      lat: '', //  39.90469,
      lng: '' // 116.40717
      // lat: 39.90469,
      // lng: 116.40717
    },
    stepperOption: getSession('stepperOption') || {},
    orderPictures: {},
    couponId: getSession('couponId'),
    carId: getSession('carId'),
    joinCouponFlag: getSession('joinCouponFlag'),
    ewScanFromOTR: getSession('ewScanFromOTR'),
    dealerFreezeFlag: getSession('dealerFreezeFlag'),
    shoppingCartDealerObj: getSession('shoppingCartDealerObj') || {},
    personWXInfor: getLocal('personWXInfor') || {
      headimgurl: ''
    },
    debug: {
      success: '',
      completegeolocation: '',
      error: '',
      errgeolocation: ''
    },
    success: '',
    boUserInfo: {
      id: ''
    },
    showdiffCarTip: true,
    openCompleteInfoPopup: true,
    profile: getSession('profile') || {},
    currentCompletedInfo: getSession('currentCompletedInfo') || {},
    registerUserInfo: {
      name: '',
      phone: ''
    },
    selectShopMenuItem: [],
    selectShopVariantItem: {},
    selectShopVariantItemFirst: {},
    myDdefaultCar: getSession('myDdefaultCar') || {},
    spuId: '',
    skuItem: {},
    isBindCar: false
  },
  mutations: {
    SETLOYALTYAPPLYdEALERPARAM(state, data) {
      state.loyaltyApplyDealerParam = data
      setSession('loyaltyApplyDealerParam', data)
    },
    SETSHOWDIFFCARTIP(state, data) {
      state.showdiffCarTip = data
    },
    SETBOUSERINFO(state, data) {
      state.boUserInfo = data
      setSession('boUserInfo', data)
    },
    SETBRANDINFO(state, data) {
      state.brandInfo = data
      setSession('brandInfo', data)
    },
    SETSHOPPINGCARTDEALEROBJ(state, data) {
      state.shoppingCartDealerObj = data
      setSession('shoppingCartDealerObj', data)
    },
    SETCURRENTNOTIFICATIONDATA(state, data) {
      state.currentNotificationData = data
    },
    SETCURRENTTYRE(state, data) {
      state.currentTyre = data
      setSession('currentTyre', data)
    },
    SETCURRENTSHOP(state, data) {
      state.currentShop = data
      setSession('currentShop', data)
    },
    SETCURRENTCONTACTS(state, data) {
      state.currentContacts = data
      setSession('currentContacts', data)
    },
    SETCURRENTCITY(state, data) {
      state.currentCity = data
      setSession('currentCity', data)
    },
    SETMYCARLIST(state, data) {
      state.myCarList = data
      setSession('myCarList', data)
    },
    SETDEARINFO(state, data) {
      state.dealerInfo = data
      setSession('dealerInfo', data)
    },
    SETLOYALTYDELERINFO(state, data) {
      state.loyaltyDealerInfo = data
      setSession('loyaltyDealerInfo', data)
    },
    SETOABINFO(state, data) {
      state.oabInfo = data
      setSession('oabInfo', data)
    },
    SETLOYALTY(state, data) {
      state.loyalty = data
      setSession('loyalty', data)
    },
    SETLOYALTYID(state, data) {
      state.loyaltyId = data
      setSession('loyaltyId', data)
    },
    SETCURRENTGOODSINFO(state, data) {
      state.currentGoodsInfo = data
      setSession('currentGoodsInfo', data)
    },
    SETCURRENTCARINFO(state, data) {
      state.currentCarInfo = data
      setSession('currentCarInfo', data)
    },
    SETCURRENTCARCLASSINFO(state, data) {
      state.currentCarClassInfo = data
      setSession('currentCarClassInfo', data)
    },
    SETCURRENTBUYPRODUCTINFO(state, data) {
      state.currentBuyProductInfo = data
      setSession('currentBuyProductInfo', data)
    },
    SETSHOPPINGCARSELECT(state, data) {
      state.shoppingCarSelect = data
      setSession('shoppingCarSelect', data)
    },
    SETDEALERJOIMPLANFLAG(state, data) {
      state.dealerJoinPlanFlag = data
      setSession('dealerJoinPlanFlag', data)
    },
    SETLOCATIONINFOR(state, data) {
      state.locationInfo = data
      setSession('locationInfo', data)
    },
    SETSTEPPEROPTION(state, data) {
      state.stepperOption = data
      setSession('stepperOption', data)
    },
    SETTYREPICTURES(state, obj) {
      // key is tyre mq
      state.orderPictures[obj.key] = obj.value
      setSession(obj.key, state.orderPictures[obj.key])
    },
    SETCARID(state, value) {
      state.carId = value
      setSession('carId', value)
    },
    SETCOUPONID(state, value) {
      state.couponId = value
      setSession('couponId', value)
    },
    SETJOINCOUPONFLAG(state, value) {
      state.joinCouponFlag = value
      setSession('joinCouponFlag', value)
    },
    SETCURRENTORDERINFO(state, value) {
      state.currentOrderInfo = value
      setSession('currentOrderInfo', value)
    },
    SETEWSCANFROMOTR(state, value) {
      state.ewScanFromOTR = value
      setSession('ewScanFromOTR', value)
    },
    SETDEALERfREEZEFLAG(state, value) {
      state.dealerFreezeFlag = value
      setSession('dealerFreezeFlag', value)
    },
    SETPERSONWXINFOR(state, value) {
      state.personWXInfor = value
      setLocal('personWXInfor', value)
    },
    SETPOSITION(state, value) {
      state.position = value
      setSession('position', value)
    },
    SETOPENCOMPLETEINFOPOPUP(state, value) {
      state.openCompleteInfoPopup = value
      setSession('openCompleteInfoPopup', value)
    },
    SETPROFILE(state, value) {
      state.profile = value
      setSession('profile', value)
    },
    SETCURRENTCOMPLETEDINFO(state, value) {
      state.currentCompletedInfo = value
      setSession('currentCompletedInfo', value)
    },
    SETREGISTERUSERINFO(state, value) {
      state.registerUserInfo = value
      // setSession('registerUserInfo', value)
      // QT上报用户属性
      const phoneNumber = mdCrtpto(value.phone)
      console.log('mdCrtpto--', value.phone, phoneNumber)
      window.mdCrtpto = mdCrtpto
      aplus_queue.push({
        action: 'aplus.record',
        arguments: [
          '$$_user_profile',
          'OTHER',
          {
            phone_number: phoneNumber
          }
        ]
      })
    },
    SETMYDEFAULTCAR(state, value) {
      state.myDdefaultCar = value
      setSession('myDdefaultCar', value)
    },
    SETSELECTSHOPMENUITEM(state, value) {
      state.selectShopMenuItem = value
      // setSession('selectShopMenuItem', value)
    },
    SETSELECTSHOPVARIANTITEM(state, value) {
      state.selectShopVariantItem = value
      setSession('selectShopVariantItem', value)
    },
    SETSELECTSHOPVARIANTITEMFIRST(state, value) {
      state.selectShopVariantItemFirst = value
      setSession('selectShopVariantItemFirst', value)
    },
    SETSPUID(state, value) {
      state.spuId = value
    },
    SETSkUITEM(state, value) {
      state.skuItem = value
      setSession('skuItem', value)
    },
    SETISBINDCAR(state, value){
      state.isBindCar = value
    }
  },
  actions: {
    setBrandInfo: ({ commit }, data) => {
      commit('SETBRANDINFO', data)
    },
    setDealerInfo: ({ commit }, data) => {
      commit('SETDEARINFO', data)
    },
    setLoyaltyDealerInfo: ({ commit }, data) => {
      commit('SETLOYALTYDELERINFO', data)
      commit('SETDEARINFO', data)
    },
    setOabInfo: ({ commit }, data) => {
      commit('SETOABINFO', data)
    },
    setPersonWXInfor: ({ commit }, data) => {
      commit('SETPERSONWXINFOR', data)
    },
    getCountOfShoppingCar: async ({ state }) => {
      let { count } = await getCountOfShoppingCar()
      state.shoppingCarCount = count
    },
    setMyCarList: ({ commit }, data) => {
      commit('SETMYCARLIST', data)
      let defaultCar = data && data.find(({ defaultFlag }) => defaultFlag)
      defaultCar && commit('SETMYDEFAULTCAR', defaultCar)
    },
    setLoyalty: ({ commit }, data) => {
      commit('SETLOYALTY', data)
    },
    setCurrentGoodsInfo: ({ commit }, data) => {
      commit('SETCURRENTGOODSINFO', data)
    },
    setCurrentCarInfo: ({ commit }, data) => {
      commit('SETCURRENTCARINFO', data)
    },
    setCurrentCarClassInfo: ({ commit }, data) => {
      commit('SETCURRENTCARCLASSINFO', data)
    },
    setCurrentBuyProductInfo: ({ commit }, data) => {
      commit('SETCURRENTBUYPRODUCTINFO', data)
    },
    setShoppingCarSelect: ({ commit }, data) => {
      commit('SETSHOPPINGCARSELECT', data)
    },
    setDealerJoinPlanFlag: ({ commit }, data) => {
      commit('SETDEALERJOIMPLANFLAG', data)
    },
    getLocation: ({ state, commit }) => {
      try {
        let geolocation = new BMap.Geolocation();
        geolocation.getCurrentPosition(
          async function(result) {
            if (this.getStatus() === BMAP_STATUS_SUCCESS) {
              // 定位成功
              console.log("----Geolocation 定位成功----", result);
              state.success = result;
              commit("SETLOCATIONINFOR", {
                city: result.address.city,
                province: result.address.province,
              });
              commit("SETPOSITION", result.point);
              result.time = `${new Date()}`;
              state.debug.success = result;
              state.debug.completegeolocation = geolocation;

              try {
                state.formattedAddress = await getCompleteAddress(result.point);
              } catch (error) {
                state.formattedAddress = "获取地址失败";
              }
            } else {
              // 定位失败, 使用城市定位 【备注：此逻辑源自使用“高德地图”的逻辑，定位失败时使用城市定位，只存了定位结果，但又没有解码城市定位的位置，原因未知】
              let myCity = new BMap.LocalCity();
              myCity.get(function(result) {
                if (!result) {
                  state.formattedAddress = "城市定位失败";
                  return;
                }
                result.time = `${new Date()}`;
                state.debug.error = result;
                state.debug.errgeolocation = myCity;

                let geocoder = new BMap.Geocoder(); // 使用Geocoder位置解析
                geocoder.getPoint(result.name, function(point) {
                  if (!point) {
                    return;
                  }
                  geocoder.getLocation(point, function(geoResult) {
                    if (!geoResult) {
                      return;
                    }
                    commit("SETLOCATIONINFOR", {
                      city: geoResult.addressComponents.city,
                      province: geoResult.addressComponents.province,
                    });
                    console.log(
                      "城市定位成功,使用Geocoder位置解析成功",
                      geoResult
                    );
                  });
                });
              });
            }
          },
          { enableHighAccuracy: true }
        );
      } catch (error) {
        console.log("bMap定位:" + JSON.stringify(error));
      }
    },
    getRegisterUserInfo: async ({ state, commit }) => {
      let { phone, username, carAge, fin, vin, model } = await getCustomerInfo()
      let headimgurl = state.personWXInfor?.headimgurl.replace('http', 'https')
      let openid = state.personWXInfor?.openid
      let CiamId = state.personWXInfor?.CiamId
      // QT配置用户属性
      aplus_queue.push({
        action: 'aplus.setMetaInfo',
        arguments: ['_user_id', openid]
      })
      // 追加QT全局属性
      aplus_queue.push({
        action: 'aplus.appendMetaInfo',
        arguments: ['globalproperty', { union_id: CiamId }]
      })
      commit('SETREGISTERUSERINFO', { phone, username, carAge, fin, vin, model, headimgurl, CiamId, openid })
    },
    getMyDdefaultCar: async ({ state, commit }) => {
      let data = await getMyDefault()
      commit('SETMYDEFAULTCAR', data)
    },
    getBindCarStatus: async ({ state, commit }) => {
      let { list } = await getMyCarList()
      commit('SETISBINDCAR', list && list.length > 0)
    }
  },
  getters: {
    orderPicture: state => mbpn => {
      if (state.orderPictures[mbpn] === undefined) {
        return []
      }
      return state.orderPictures[mbpn]
    }
  },
  modules: {}
})
